import React from 'react';
import { connect } from 'react-redux';
import { IDispatchProp } from 'restdux';
import { 
  Card,
  CardContent,
  Divider,
  Fab,
  FormControl,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  MenuItem,
  Select,
  TextField,
  Theme,
  Typography,
  withTheme, 
  WithTheme 
} from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/styles';
import { Add as AddIcon, NavigateNext } from '@material-ui/icons';
import '../../styles/App.css';
import MainLayout from '../../components/MainLayout';
import LoadIndicator from '../../components/LoadIndicator';
import RoleGate from '../../components/RoleGate';
import StatusCodeItem from '../../components/statuscode/Item';
import StatusCodeAddModal from '../../components/statuscode/AddEditModal';
import { actions as statuscodeActions, IReturn as StatusCode } from '../../api/resources/StatusCode';
import { ApplicationState } from '../../reducers';

const styles = (theme: Theme) =>
    createStyles({
        fab: {
          position: 'fixed',
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        },      
        searchBar: {
          display: 'flex',
          justifyContent: 'space-between',
          margin: '16px 0',
        },
        filterBox: {
          minWidth: 120,
        },
        filler: {
          display: 'flex',
          flex: 1
        }
    });

interface IProps {
  statusCodes: StatusCode[];
}

const mapStateToProps = (state: ApplicationState) => {
  return {
    statusCodes: Object.values(state.statuscode.data),
  };
}

type FullProps = IProps & WithStyles<typeof styles> & WithTheme & IDispatchProp;
class StatusCodes extends React.PureComponent<FullProps> {
  state = {
    isLoading: false,
    search: '',
    showAddModal: false,
  }
  
  componentDidMount() {
    this.retrieveData();
  }

  public async retrieveData() {
    const { dispatch } = this.props;
    const { search } = this.state;
    if (search) {
      dispatch(statuscodeActions.index(undefined, undefined, {search}));
    }
    else {
      dispatch(statuscodeActions.index(undefined, undefined, {}));
    }
  }
  
  render() {
    const { statusCodes: codes, classes } = this.props;
    const { isLoading, search, showAddModal } = this.state;

    const codesMarkup = codes
      .filter((code) => !search || code.description.toLowerCase().indexOf(search.toLowerCase()) >= 0)
      .map((code, index) => {
        return (
          <StatusCodeItem index={index} statuscode={code} key={index} />
        )
      });
    
    return (
      <MainLayout title='Manage Status Codes'>
          <RoleGate role='admin' />
          {isLoading ? (
            <LoadIndicator />
          ) : (
            <>
              <div className={classes.searchBar}>
                <div className={classes.filler} />
                <TextField label="Search" variant="filled" onChange={(evt) => this.setState({search:evt.target.value})} />
                {/* <FormControl variant="filled" className={classes.filterBox}>
                  <InputLabel id="filter-label">Filter</InputLabel>
                  <Select
                    labelId="filter-label"
                    value={filter}
                    onChange={this.handleFilterChange}
                  >
                    <MenuItem value={'all'}><em>None</em></MenuItem>
                    <MenuItem value={'active'}>Active</MenuItem>
                  </Select>
                </FormControl> */}
              </div>
              <Card>            
                <CardContent>
                  <List>
                    { codesMarkup }                
                  </List>
                </CardContent>
              </Card>
            </>
          )}
          <Fab color="primary" aria-label="add" className={classes.fab} onClick={this.handleAddClick}>
            <AddIcon />
          </Fab>
          <StatusCodeAddModal open={showAddModal} onDismiss={this.handleDismiss} />
      </MainLayout>
    );
  }

  private handleAddClick = () => {
    this.setState({showAddModal: true});
  }

  private handleDismiss = (shouldRefresh: boolean) => {
    this.setState({showAddModal: false});
  }
}

export default connect(mapStateToProps)(withTheme(withStyles(styles)(StatusCodes)));